// extracted by mini-css-extract-plugin
export default {"BookRatingForm":"BookRatingForm_BookRatingForm__qJndL","Stars":"BookRatingForm_Stars__F3AO2"};